<template>
  <div>
    <div :id="id" class="user-content" v-html="content"/>
    <div style="clear:both;">&nbsp;</div>
  </div>
</template>

<script>
export default {
  name: 'UserContent',
  props: {
    content: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    }
  },
  watch: {
    content: function (newVal, oldVal) {
      this.fixContent()
    }
  },
  mounted() {
    this.fixContent()
  },
  methods: {
    fixContent() {
      this.$nextTick(function () { /*Need to wait for content to get rendered!*/
        let doc = document.getElementById(this.id)
        let elements = doc.getElementsByTagName("img")
        for (let el of elements) {
          let width = el.getAttribute("width");
          let height = el.getAttribute("height");
          if (!width) return
          if (width.indexOf("%") != -1) return;

          let widthNum = Number(width.replace("px", ""))
          if (widthNum < 100) {
            return;
          }
          el.setAttribute("width", "100%");
          el.setAttribute("height", "");
        }
      })
    }
  }
};
</script>
<style>
.user-content strong {
  font-weight: bold !important;
}

</style>


